import { useState } from 'react'
import TableHeader from './TableHeader'
import TableNavigation from './TableNavigation'

const ExcelTableContainer = () => {
  const [totalRecords, setTotalRecords] = useState<any>(null)
  const [columns, setColumns] = useState(null)

  return (
    <div
      style={{
        height: '85vh',
        width: '100%',
        // overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <div style={{ height: '20%' }}>
        <TableNavigation totalRecords={totalRecords} columns={columns} />
      </div>

      <div style={{ height: '80%' }}>
        <TableHeader totalRecors={setTotalRecords} setColumns={setColumns} />
      </div>
    </div>
  )
}

export default ExcelTableContainer
